var PRECISION = 0.00001; // numbers less than this is considered as 0

module.exports = function isNumberEqual(a, b) {
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PRECISION;
  return Math.abs(a - b) < precision;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/is-number-equal.js
// module id = 30
// module chunks = 0 1 2